import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz35 = () => {
    return (
        <div>
            <NavLink to='/category/Puzzels/Puzzel36'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel34'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article
    class="container">
    <h1 class="title">2 Eggs and 100 Floors</h1>
   
    <div class="text">
        <p>The following is a description of the instance of this famous puzzle involving 2 eggs and a building with 100
            floors.</p>
        <p>Suppose that we wish to know which stories in a 100-story building are safe to drop eggs from, and which will
            cause the eggs to break on landing. What strategy should be used to drop eggs such that total number of
            drops in worst case is minimized and we find the required floor.</p>
            <div className='containers'>
        <p>We may make a few assumptions:</p>
        <ul>
            <li>An egg that survives a fall can be used again.</li>
            <li>A broken egg must be discarded.</li>
            <li>The effect of a fall is the same for all eggs.</li>
            <li>If an egg breaks when dropped, then it would break if dropped from a higher floor.</li>
            <li>If an egg survives a fall then it would survive a shorter fall.</li>
        </ul>
        </div>
        <p>If <strong>only one egg is available</strong> and we wish to be sure of obtaining the right result, the
            experiment can be carried out in only one way. Drop the egg from the first-floor window; if it survives,
            drop it from the second floor window. Continue upward until it breaks. In the worst case, this method may
            require 100 droppings.<br/>
            Suppose 2 eggs are available. What is the least number of egg-droppings that is
            guaranteed to work in all cases?<br/>
            The problem is not actually to find the critical floor, but merely to
            decide floors from which eggs should be dropped so that total number of trials are minimized.</p><br/>

        

        <p>If we use <strong>Binary Search Method </strong>to find the floor and we start from 50’th floor, then we end
            up doing 50 comparisons in worst case. The worst case happens when the required floor is 49’th floor.</p>
        <p><strong>Optimized Method:</strong><br/>
            The idea is to do optimize the solution using below equation:</p>
        <pre>Let us make our first attempt on x'th floor.  <br/>
     <br/>
    If it breaks, we try remaining (x-1) floors one by one.  <br/>
    So in worst case, we make x trials. <br/>
     <br/>
    If it doesn’t break, we jump (x-1) floors (Because we have <br/>
    already made one attempt and we don't want to go beyond  <br/>
    x attempts.  Therefore (x-1) attempts are available), <br/>
        Next floor we try is floor x + (x-1) <br/>
     <br/>
    Similarly, if this drop does not break, next need to jump  <br/>
    up to floor x + (x-1) + (x-2), then x + (x-1) + (x-2) + (x-3) <br/>
    and so on. <br/>
     <br/>
    Since the last floor to be tried is 100'th floor, sum of <br/>
    series should be 100 for optimal value of x. <br/>
    <div className='output'>
     <br/>
     x + (x-1) + (x-2) + (x-3) + .... + 1  = 100 <br/>
     <br/>
     x(x+1)/2  = 100 <br/>
             x = 13.651 <br/></div>
     <br/>
    Therefore, we start trying from 14'th floor. If Egg breaks <br/>
    we one by one try remaining 13 floors.  If egg doesn't break <br/>
    we go to 27th floor. <br/>
    If egg breaks on 27'th floor, we try floors form 15 to 26. <br/>
    If egg doesn't break on 27'th floor, we go to 39'th floor. <br/>
     <br/>
    An so on... <br/>
     <br/>
    </pre> <br/>
     
       
    </div>
</article>
        </div>
    )
}

export default Puz35
